import { Stack } from '@factorialco/f0-react/dist/experimental'
import { ExpensesEntitiesExpensableResourceTypeEnum } from 'generated/resources/graphql'
import { ExpensableBudgetFragment } from 'generated/resources/graphql'

import i18n from 'modules/core/lib/i18n'

import Budget from 'modules/expenses/components/expenses/Detail/_newForm/Blocks/mileage/Budget'
import { shouldShowBlock as shouldShowBudgetBlock } from 'modules/expenses/components/expenses/Detail/_newForm/Blocks/Budget/form/schema'
import Projects from 'modules/expenses/components/expenses/Detail/_newForm/Blocks/mileage/Projects'
import { shouldShowBlock as shouldShowProjectsBlock } from 'modules/expenses/components/expenses/Detail/_newForm/Blocks/Projects/form/schema'
import FormBlock from 'modules/expenses/components/expenses/Detail/_newForm/Sections/FormBlock'
import { CustomizationProps } from 'modules/expenses/components/expenses/Detail/_newForm/withCustomizationFields'
import { PermissionsProps } from 'modules/expenses/components/expenses/Detail/_newForm/withFieldPermissions'
import { ProjectWorker } from 'modules/expenses/hooks/useProjects'
import { BudgetOption } from 'modules/finance/hooks/useBudgets'

interface Props extends PermissionsProps, CustomizationProps {
  expensableBudget?: ExpensableBudgetFragment | null
  budgetOptions: BudgetOption[]
  projectWorkers: ProjectWorker[]
  hasProjectsFeature: boolean
  loadingProjectWorkers: boolean
  loadingBudgetOptions: boolean
  resourceType: ExpensesEntitiesExpensableResourceTypeEnum
}

const BudgetAndProject = (props: Props) => {
  const {
    hasProjectsFeature,
    projectWorkers,
    customizationFields,
    loadingProjectWorkers,
    loadingBudgetOptions,
    resourceType
  } = props

  const showProjectsBlock = shouldShowProjectsBlock(
    hasProjectsFeature,
    projectWorkers,
    customizationFields,
    resourceType
  )

  const showBudgetBlock = shouldShowBudgetBlock(
    props.budgetOptions,
    props.customizationFields,
    resourceType
  )

  if (!showProjectsBlock && !showBudgetBlock) return null

  return (
    <FormBlock
      title={i18n.t('expenses_v2.forms.new_form.blocks.budget_and_project')}
      subtitle={i18n.t('expenses_v2.forms.new_form.blocks.budget_and_project_subtitle')}
    >
      <Stack gap="6">
        <Budget {...props} loading={loadingBudgetOptions} />
        <Projects {...props} loading={loadingProjectWorkers} />
      </Stack>
    </FormBlock>
  )
}

export default BudgetAndProject
